import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ReportAPI } from '../../../api'
import { SET_USER_PROFILE_LOCATION } from '../../../redux/actions'

import Helper from './final-transshipment.helper'

const useHooks = () => {
  const dispatch = useDispatch()
  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  const currentYear = new Date().getFullYear()
  const currentMonth = new Date().getMonth() + 1

  const [filter, setFilter] = useState({
    year: { value: currentYear, label: currentYear.toString() },
    month: { value: currentMonth, label: Helper.ListMonths[currentMonth - 1].label },
    location: Location?.LocationID,
  })
  const [total, setTotal] = useState(0)
  const [dataTable, setDataTable] = useState({
    data_final_transshipment: null,
    data_column_transshipment: null,
    data_summary_transshipment: null,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [isExporting, setIsExporting] = useState(false)

  const handleLocationChange = (value) => {
    const valueLocation = UserLocations.find(
      (e) => e.LocationDescription === value
    )

    setFilter({
      ...filter,
      location: valueLocation?.LocationID
    })

    dispatch({
      type: SET_USER_PROFILE_LOCATION,
      payload: valueLocation
    })
  }

  const handleMonthChange = (event) => {
    setFilter({
      ...filter,
      month: event.value
    })
  }

  const handleYearChange = (event) => {
    const selectedYear = event.value
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth() + 1

    let newMonth = filter.month

    // If selected year is in the future, reset month
    if (selectedYear > currentYear) {
      newMonth = ''
    }
    // If selected year is current year and selected month is in the future, reset month
    else if (selectedYear === currentYear && filter.month > currentMonth) {
      newMonth = ''
    }

    setFilter({
      ...filter,
      year: selectedYear,
      month: newMonth
    })
  }

  const fetchFinalTransshipment = async (payload) => {
    try {
      setIsLoading(true)
      const response = await ReportAPI.GetReportFinalTransshipment(payload)

      if (response.error !== '') throw new Error('Failed to fetch data')
      if (response.error === '' && response.data) {
        setDataTable(response.data)
      }
    } catch (error) {
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (filter.location && filter.month && filter.year) {
      const selectedDate = new Date(filter.year.value, filter.month.value - 1, 1)
      const payload = {
        location: filter.location,
        filterPeriod: moment(selectedDate).format('YYYY-MM-DD'),
      }
      fetchFinalTransshipment(payload)
    }
  }, [filter.location, filter.month, filter.year])

  const handleExportReport = async () => {
    try {
      setIsExporting(true)
      const selectedDate = new Date(filter.year.value, filter.month.value - 1, 1)
      const payload = {
        location: filter.location,
        filterPeriod: moment(selectedDate).format('YYYY-MM-DD'),
      }

      const response = await ReportAPI.ExportReportFinalTransshipment(payload)

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      const locationDescription = String(Location?.LocationDescription || '')
        .toLowerCase()
        .replace(/ /g, '-')

      const filename = `final-transshipment-report-${locationDescription}-${moment(selectedDate).format('YYYY-MM-DD')}.xlsx`

      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // Release memory
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Export failed:', error)
    } finally {
      setIsExporting(false)
    }
  }

  return {
    data: {
      total,
      filter,
      dataTable,
      isLoading,
      isExporting,
      UserLocations,
    },
    methods: {
      setTotal,
      setIsLoading,
      handleYearChange,
      handleMonthChange,
      handleExportReport,
      handleLocationChange,
    }
  }
}

export default useHooks
